module.exports = __webpack_public_path__ + "static/media/whenyouwishuponastar.07afaf2a.png";